import styled from 'styled-components';

const ProductsSliderStyle = styled.section`
	--distanceItemSlide: var(--sp4x);
	--slideWidthWw: 26.5625vw;
	--slideWidth: calc(var(--distanceItemSlide) + var(--slideWidthWw));
	--distanceSlideText: var(--sp9x);

	overflow: hidden;

	.wrapper-button-info {
		transform: scale(0);
	}

	.swiper {
		overflow: visible;
		margin-right: calc(var(--distanceItemSlide) * -1);
	}

	.swiper-slide {
		width: var(--slideWidth) !important;
		overflow: visible !important;

		.wrapper-item-slide {
			margin-right: var(--distanceItemSlide);
		}
	}

	.wrapper-title-button {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: var(--distanceSlideText);
		gap: var(--sp3x);
	}
	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceItemSlide: var(--sp4x);
		--slideWidthWw: 26.51vw;
		--distanceSlideText: var(--sp8x);
	}
	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceItemSlide: var(--sp3x);
		--slideWidthWw: 26.17vw;
		--distanceSlideText: var(--sp5x);
	}
	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--slideWidthWw: 26.134vw;
		--distanceSlideText: var(--sp4x);
	}
	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceItemSlide: var(--sp2-5x);
		--slideWidthWw: 25.7vw;
	}
	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--slideWidthWw: 25.1vw;
	}
	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--slideWidthWw: 32.9vw;
		--distanceItemSlide: var(--sp2x);
		--distanceSlideText: var(--sp3x);
	}
	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--slideWidthWw: 100%;
		--distanceItemSlide: var(--sp5x);
		--distanceSlideText: var(--sp5x);

		.wrapper-slide {
			display: flex;
			flex-direction: column;
			gap: var(--distanceItemSlide);
		}

		.wrapper-title-button {
			flex-direction: column;
			align-items: flex-start;
		}
	}
`;
export default ProductsSliderStyle;
